import closures from '../../Server.Shared/Reservations/program-closures.json';

type ClosureLabel = { label: string; reason?: string | null };

export function programClosureNote(closures: readonly ClosureLabel[]): string {
    const labels = [...new Set(closures.map(c => c.reason?.trim() ? `${c.label} (${c.reason.trim()})` : c.label))];
    if (!labels.length) return '';
    const dates = labels.length <= 2 ? labels.join(' and ')
        : `${labels.slice(0, -1).join(', ')}, and ${labels[labels.length - 1]}`;
    return `Excludes ${dates}, when programs are paused.`;
}

const localDate = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit',
});

function dayNumber(value: Date): number {
    const parts = Object.fromEntries(localDate.formatToParts(value).map(p => [p.type, p.value]));
    return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)) / 86400000;
}

/** Service days for labels only. Never use this for rate-plan eligibility. */
export function programOperatingDays(start: Date, end: Date): { days: number; closureNote: string } {
    if (!Number.isFinite(start?.getTime()) || !Number.isFinite(end?.getTime())) return { days: 0, closureNote: '' };
    const first = dayNumber(start);
    const last = dayNumber(end);
    if (last < first) return { days: 0, closureNote: '' };
    let days = last - first + 1;
    const excluded: ClosureLabel[] = [];
    for (let year = new Date(first * 86400000).getUTCFullYear(); year <= new Date(last * 86400000).getUTCFullYear(); year++) {
        for (const closure of closures) {
            const date = Date.UTC(year, closure.month - 1, closure.day) / 86400000;
            if (date >= first && date <= last) { days--; excluded.push(closure); }
        }
    }
    return { days, closureNote: programClosureNote(excluded) };
}

export function programDurationLabel(start: Date, end: Date): string {
    const duration = programOperatingDays(start, end);
    return `${duration.days} program ${duration.days === 1 ? 'day' : 'days'}${duration.closureNote ? `; ${duration.closureNote}` : ''}`;
}
